import { Box } from "@kaltura/mediaspace-shared-styled";
import styled from "@emotion/styled";
import { useDateFormat } from "@kaltura/mediaspace-shared-hooks";
import { ChevronRight16Icon } from "@kaltura/ds-react-icons";

export interface ScheduleProps {
    startTime: number;
    endTime: number;
}

const Container = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    marginTop: theme.spacing(1),
    opacity: 0.8,
    alignItems: "center",
    fontWeight: theme.kaltura.typography.fontWeightBold,
    [theme.breakpoints.down("md")]: {
        justifyContent: "center",
    },
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        marginRight: "auto",
        marginLeft: "auto",
    },
}));

const Separator = styled("span")(({ theme }) => ({
    display: "inline-block",
    width: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
        height: theme.spacing(1),
    },
}));

/**
 * schedule component
 * renders session scheduling data (from - to)
 */
const Schedule = (props: ScheduleProps) => {
    const staticClassBase = "kms-ds-media-page-lobby-schedule";

    const { startTime, endTime } = props;

    const { startDay, endDay, formattedScheduledStartTime, formattedScheduledEndTime } = useDateFormat(
        startTime,
        endTime
    );

    if (startDay === endDay) {
        return (
            <Container className={staticClassBase}>
                {`${startDay}`}
                <Separator />
                {`${formattedScheduledStartTime} - ${formattedScheduledEndTime}`}
            </Container>
        );
    }
    else {
        return (
            <Container className={staticClassBase}>
                {`${startDay}, ${formattedScheduledStartTime}`}
                <Separator />
                <ChevronRight16Icon />
                <Separator />
                {`${endDay}, ${formattedScheduledEndTime}`}
            </Container>
        );
    }
};

export default Schedule;
